const REQUIRED_FIELDS = {
  view_house: ["houseId"],
  open_availability: ["houseId"],
  search_availability: ["houseId", "startDate", "endDate"],
  start_reservation: ["houseId", "startDate", "endDate"],
  submit_reservation: ["houseId", "startDate", "endDate"],
  update_cookie_consent: ["essential", "analytics", "marketing"],
  update_site_settings: [],
  update_hero_sliders: [],
  create_user: ["username", "roleCode"],
  send_consent_email: ["reservationId"],
  click_whatsapp_channel: ["placement"],
  click_instagram_channel: ["placement"],
};

const LAKEVIEW_AVAILABILITY_SEND_TO = "AW-18281999658/yg3DCPaarcccEKraxI1E";
const LAKEVIEW_QUOTE_SEND_TO = "AW-18281999658/TRvwCLyKk8ccEKraxI1E";

function isLakeviewHost() {
  if (typeof window === "undefined") return false;
  const host = String(window.location.hostname || "").toLowerCase();
  return host.includes("lakeviewvillaresort");
}

function validatePayload(eventName, payload) {
  const required = REQUIRED_FIELDS[eventName] || [];
  const missing = required.filter((k) => payload?.[k] === undefined || payload?.[k] === null || payload?.[k] === "");
  return missing;
}

export function trackEvent(eventName, payload = {}) {
  const safePayload = { ...payload };
  const missing = validatePayload(eventName, safePayload);

  if (process.env.NODE_ENV !== "production" && missing.length) {
    // eslint-disable-next-line no-console
    console.warn(`[tracking] missing fields for ${eventName}:`, missing);
  }

  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", eventName, safePayload);
  }

  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", eventName, safePayload);
  }

  if (process.env.NODE_ENV !== "production") {
    // eslint-disable-next-line no-console
    console.info("[tracking]", eventName, safePayload);
  }
}

export function trackGoogleAdsConversion(type, options = {}) {
  if (!isLakeviewHost()) return true;
  if (typeof window === "undefined" || typeof window.gtag !== "function") return true;

  const sendTo =
    type === "availability"
      ? LAKEVIEW_AVAILABILITY_SEND_TO
      : type === "quote"
        ? LAKEVIEW_QUOTE_SEND_TO
        : "";

  if (!sendTo) return true;

  const { url } = options;
  const callback = function () {
    if (typeof url !== "undefined" && url) {
      window.location = url;
    }
  };

  window.gtag("event", "conversion", {
    send_to: sendTo,
    event_callback: callback,
  });

  return false;
}
